export default __webpack_public_path__ + "static/media/ofs_800_jacket_2.223db179.jpg";